import { ThemeProps } from './theme';

export type ThemeColorName =
  | 'cPrimary'
  | 'cSecondary'
  | 'cError'
  | 'cText';

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const styledConsts = {
  formItemHeight: 57, // px
  shadowColor: `rgba(0, 1, 52, 0.12)`,
  cPrimary: ({ theme }: ThemeProps) => theme.palette.primary.main,
  cSecondary: ({ theme }: ThemeProps) => theme.palette.secondary.main,
  cWarning: ({ theme }: ThemeProps) => theme.palette.warning.main,
  cError: ({ theme }: ThemeProps) => theme.palette.error.main,
  cText: ({ theme }: ThemeProps) => theme.palette.text.primary,
};

export default styledConsts;
